import React from 'react'
import AuthLayoutHeader from '../components/auth/AuthLayoutHeader'
import SignInForm from '../components/auth/SignInForm'

const SignIn: React.FC = () => {
  return (
    <>
      <AuthLayoutHeader title="Login" />
      <span className="mt-6 block bg-white text-gray-500">
        Please enter the email address and password associated with your account.
      </span>

      <div className="mt-6">
        <SignInForm />
        <div className="relative py-6">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className=" bg-white text-gray-500">
              If you do not have a Buzzjar account, please email us at{' '}
              <a className="text-link" href="mailto:hello@buzzjar.com" target="_blank" rel="noreferrer">
                hello@buzzjar.com
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignIn
